<template>
    <ReactPage>
      <prize-adjustment-report-page></prize-adjustment-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "PrizeAdjustmentReport",
    components: {
      ReactPage
    }
  }
  </script>
